/**
 * Created by lycheng on 2017/11/23.
 * 弹出层的处理
 */
import 'babel-polyfill'
import { layer } from 'js/libs/utils-layer'
$('.modal-wrapper').on('click', '.modal-close, .modal-button-cancle', function () {
  layer.close($(this).parents('.modal-wrapper:eq(0)'))
})



// WEBPACK FOOTER //
// ./src/js/libs/utils-modal.js